import React, { memo, useEffect } from 'react';
import { useAvvenimenti, useInfoTemplateManifestazione } from 'features/sport/hooks';

import { SkeletonArea } from 'components/skeletonArea';
import { DynamicSportMarcatoriCarousel as SportMarcatoriCarousel } from 'features/sport/components/sportMarcatoriCarousel';
import { DynamicSportTableScommesse as SportMarcatoriTable } from 'features/sport/components/sportMarcatoriTableScommesse';
import { SportTableScommesse } from 'features/sport/components/sportTableScommesse';
import { SportTableScommesseHeadersSticky } from 'features/sport/components/sportTableScommesse/sportTableScommesseHeadersSticky';
import { isTruthy } from 'utility/functions';
import { setAvvenimentoSelected } from 'features/sport/marcatoriSlice';
import styles from './PageContent.module.scss';
import { useAppDispatch } from 'lib/centralStore';

interface MarcatoriTableProps {
  suppressLoader?: boolean;
  infoTipoScommessaKeyList: Array<string>;
}
const MarcatoriTable = ({ suppressLoader, infoTipoScommessaKeyList }: MarcatoriTableProps) => {
  const dispatch = useAppDispatch();
  const avvenimentoList = useAvvenimenti();
  const { isScommessaLoading } = useInfoTemplateManifestazione();

  useEffect(() => {
    if (isTruthy(avvenimentoList?.length)) {
      dispatch(
        setAvvenimentoSelected({
          avvenimentoKey: avvenimentoList?.[0]?.key ?? '',
          competitor: 1,
        })
      );
    }
  }, [avvenimentoList, dispatch]);

  return (
    <React.Fragment>
      <SportMarcatoriCarousel
        hasVerticalMargin
        avvenimentoKeys={avvenimentoList?.map((avvenimento) => avvenimento.key!)}
      />
      {isScommessaLoading ? (
        new Array(suppressLoader ? 0 : 10)
          .fill(0)
          .map((_, index) => <SkeletonArea key={index} className={styles.skeletonRow} delay={index} />)
      ) : (
        <SportMarcatoriTable infoTipoScommessaKeyList={infoTipoScommessaKeyList} />
      )}
    </React.Fragment>
  );
};

interface SportTableProps extends MarcatoriTableProps {
  isHeaderVisible?: boolean;
}
const SportTable = ({ isHeaderVisible, suppressLoader, infoTipoScommessaKeyList }: SportTableProps) => {
  const avvenimentoList = useAvvenimenti();

  return (
    <React.Fragment>
      {isHeaderVisible && <SportTableScommesseHeadersSticky infoTipoScommessaKeyList={infoTipoScommessaKeyList} />}
      <SportTableScommesse
        avvenimenti={(avvenimentoList ?? []).map((avv) => ({
          key: avv.key,
          firstPriority: avv.dataOra,
        }))}
        showTableTitle
        suppressLoader={suppressLoader}
        sortAvvenimenti
        hasHeaderScommessa
        isManifestazioneTemplate={true}
        infoTipoScommessaKeyList={infoTipoScommessaKeyList}
      />
    </React.Fragment>
  );
};

interface SportManifestazioneTableProps extends SportTableProps {
  isMarcatore?: boolean;
}

const SportManifestazioneTable = memo(function SportManifestazioneTable(props: SportManifestazioneTableProps) {
  if (isTruthy(Reflect.get(props ?? {}, 'isMarcatore'))) {
    return <MarcatoriTable {...props} />;
  }

  return <SportTable {...props} />;
});

SportManifestazioneTable.displayName = 'SportManifestazioneTable';

export default SportManifestazioneTable;
